/* global window */

import { Component } from 'react';

import Item from 'common/components/item/Item';
import { getMessage } from 'common/helpers/miscHelper';

import CartCarrot from './CartCarrot';
import CartErrors from './CartErrors';
import CartSummary from './CartSummary';
import CouponForm from './CouponForm';
import CouponsAndPromos from './CouponsAndPromos';

class CartDisplay extends Component {
  constructor(props) {
    super(props);

    this.state = {
      promoVisible: false
    };

    this.handlePromoVisible = this.handlePromoVisible.bind(this);
  }

  handlePromoVisible(e) {
    e.preventDefault();
    const { promoVisible } = this.state;

    this.setState({
      promoVisible: !promoVisible
    });
  }

  redirectToStoreFront = (e) => {
    const { settings } = this.props;
    e.preventDefault();
    window.location.href = settings.data.continueShopping;
  };

  render() {
    const { cart, settings } = this.props;
    const { promoVisible } = this.state;
    // const couponInUse = cart.

    if (!cart.items || cart.items.length === 0) {
      return (
        <div
          className="c7-message--empty-cart"
          dangerouslySetInnerHTML={{
            __html: getMessage('Empty Cart', settings)
          }}
          onClick={this.redirectToStoreFront}
        />
      );
    }
    return (
      <>
        <CartErrors cart={cart} />
        <div className="c7-cart-items">
          {cart.items.map((item) => (
            <Item item={item} key={item.id} settings={settings} />
          ))}
        </div>
        <CartCarrot location="Cart Page Inline" cart={cart} />
        <div className="c7-cart__summary">
          <div className="c7-cart__summary__message">
            <a href="#" onClick={this.handlePromoVisible}>
              Have a coupon code or gift card?
            </a>

            <CouponForm isVisible={promoVisible} cart={cart} />
            <CouponsAndPromos cart={cart} settings={settings} />
            <div
              dangerouslySetInnerHTML={{
                __html: getMessage('Cart Help', settings)
              }}
            />
          </div>

          <div className="c7-cart__summary__totals">
            <CartSummary cart={cart} settings={settings} />
          </div>
        </div>
      </>
    );
  }
}

export default CartDisplay;
